import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass, Home } from 'lucide-react';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found animate-fade-in">
      <div className="not-found__icon">
        <Compass size={48} strokeWidth={1.5} />
      </div>
      <h1 className="not-found__title">Page not found</h1>
      <p className="not-found__text">
        The page you're looking for doesn't exist or may have been moved.
        Use the menu on the left, or go back to your dashboard.
      </p>
      <button className="btn btn-primary" onClick={() => navigate('/')}>
        <Home size={16} />
        Back to Dashboard
      </button>
    </div>
  );
};

export default NotFound;
